import { Native } from "../../platform/android/nativeBridge.js";

const app_type = Native.isAndroid
  ? "in.loanfront.android"
  : Native.isIOS
    ? "in.loanfront.ios"
    : "in.loanfront.web";

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL,
  TIMEOUT: 30000,
  DEFAULT_HEADERS: {
    "Content-Type": "application/json",
    appType: app_type,
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: 0,
  },
};
